import { useQuery } from '@apollo/client';
import { graphql } from '../graphql';
import { useCallback, useMemo, useRef } from 'react';
import { getRandomInt } from '../lib/utils';
export const RECEIVE_EVENTS = graphql(`
  query ReceiveEvents($timestamp: String!) {
    getEvents(input: { timestamp: $timestamp }) {
      id
      persistedTimestamp
      source
      type
      actionEvent {
        action
        remarks
      }
      supportCaseStatusEvent {
        by
        status
        reason
      }
      messageStatusEvent {
        status
        messageId
      }
      messagingStateEvent {
        from
        state
      }
      messageEvent {
        messageType
        from
        text {
          message
        }
        attachment {
          url
          caption
        }
        question {
          text
          options {
            value
            label
            description
            optionType
          }
        }
        command {
          text
          items {
            command
            label
          }
        }
        secureForm {
          invitationId
          url
          title
        }
      }
    }
  }
`);
const defaultOptions = {
    onReceiveData: () => { },
    onPoll: () => { },
    onError: () => { },
    skip: false,
};
export const useReceiveEvents = (options = {}) => {
    var _a;
    const { onReceiveData, onPoll, onError, skip } = Object.assign(Object.assign({}, defaultOptions), options);
    const timestamp = useRef('0');
    const pollInterval = useMemo(() => 900 + getRandomInt(0, 200), []);
    const onCompletedWithLatestTimestamp = useCallback((data) => {
        var _a, _b, _c, _d;
        if (((_a = data === null || data === void 0 ? void 0 : data.getEvents) === null || _a === void 0 ? void 0 : _a.at(-1)) !== null) {
            const newTimestamp = +((_c = (_b = data.getEvents.at(-1)) === null || _b === void 0 ? void 0 : _b.persistedTimestamp) !== null && _c !== void 0 ? _c : 0);
            if (newTimestamp > 0 && newTimestamp.toString() !== timestamp.current) {
                timestamp.current = newTimestamp.toString();
            }
        }
        if (((_d = data === null || data === void 0 ? void 0 : data.getEvents) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            onReceiveData(data);
        }
        onPoll();
    }, [onReceiveData, onPoll]);
    const queryResult = useQuery(RECEIVE_EVENTS, {
        variables: { timestamp: timestamp.current },
        pollInterval,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        onCompleted: onCompletedWithLatestTimestamp,
        onError,
        skip,
    });
    return Object.assign(Object.assign({}, queryResult), { data: (_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.getEvents });
};
//# sourceMappingURL=useReceiveEvents.js.map